import { RollbackButtonComponent } from './components/atoms/rollback-button/rollback-button.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgZorroAntdModule } from 'src/app/ng-zorro-antd.module';
import { ChartOptions } from './classes';
import {
  ButtonComponent,
  ChartComponent,
  DatePickerRangeComponent,
  DatePickerRangeTitleComponent,
  DropDownComponent,
  InputComponent,
  InputTitleComponent,
  LabelComponent,
  SelectComponent,
  SelectTitleComponent,
  TableComponent,
  TitleComponent,
} from './components';
import { CommaLinebreakPipe } from './utils/comma-linebreak.pipe';
import { AbsolutenumPipe } from './utils/absolutenum.pipe';
import { CommonPipeModule } from 'src/app/shared/pipes/common-pipe.module';
import { WmsmConditionsComponent } from './components/wmsm/wmsm-conditions/wmsm-conditions.component';
import { WmsmRtConditionsComponent } from './components/wmsm/wmsm-Rtconditions/wmsm-Rtconditions.component';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { WmsmAnalysisconditionsComponent } from './components/wmsm/wmsm-Analysisconditions/wmsm-Analysisconditions.component';
import { WmsmKanbanditionsComponent } from './components/wmsm/wmsm-Kanbanditions/wmsm-Kanbanditions.component';
import { WmsmWHQRtConditionsComponent } from './components/wmsm/wmsm-WHQRtconditions/wmsm-WHQRtconditions.component';
import { WmsmContractComponent } from './components/wmsm/wmsm-contract/wmsm-contract.component';
import { WmsmAribaconditionsComponent } from './components/wmsm/wmsm-Aribaconditions/wmsm-Aribaconditions.component';
import { CommonDirectiveModule } from './directives/common-directive.module';
export function createTranslateHttpLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroAntdModule,
    CommonDirectiveModule,
    //I18N
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateHttpLoader,
        deps: [HttpClient],
      },
    })
  ],
  declarations: [
    DatePickerRangeComponent,
    SelectComponent,
    TitleComponent,
    DatePickerRangeTitleComponent,
    SelectTitleComponent,
    ButtonComponent,
    TableComponent,
    LabelComponent,
    DropDownComponent,
    InputComponent,
    InputTitleComponent,
    ChartComponent,
    CommaLinebreakPipe,
    AbsolutenumPipe,
    WmsmConditionsComponent,
    WmsmContractComponent,
    WmsmRtConditionsComponent,
    WmsmAnalysisconditionsComponent,
    WmsmKanbanditionsComponent,
    WmsmWHQRtConditionsComponent,
    WmsmAribaconditionsComponent,
    RollbackButtonComponent
  ],
  exports: [
    DatePickerRangeComponent,
    SelectComponent,
    TitleComponent,
    DatePickerRangeTitleComponent,
    SelectTitleComponent,
    ButtonComponent,
    TableComponent,
    LabelComponent,
    DropDownComponent,
    InputComponent,
    InputTitleComponent,
    ChartComponent,
    CommaLinebreakPipe,
    AbsolutenumPipe,
    CommonPipeModule,
    WmsmConditionsComponent,
    WmsmContractComponent,
    WmsmRtConditionsComponent,
    WmsmAnalysisconditionsComponent,
    WmsmKanbanditionsComponent,
    WmsmWHQRtConditionsComponent,
    WmsmAribaconditionsComponent,
    CommonDirectiveModule,
    RollbackButtonComponent
  ],
  providers: [ChartOptions, WmsmWHQRtConditionsComponent, BaseComponent],
})
export class ShareModule { }
